export default "__VITE_ASSET__Ct2Ctoww__"